/**
 * Validator JS controller.
 *
 * This class handles validation of form inputs.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Validator. This gets mapped with the keyword Validator and its
 * docready method is fired automatically on pages where there's a
 * class called 'Validator' on the html tag.
 */
class Validator {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements and variables for use in the methods
     */
    cache() {

        // Error messages grouped by error type.
        this.errors = {
            input: {
                number: themeData.themeStrings.form.errors.input.number
            },
            empty: {
                text: themeData.themeStrings.form.errors.empty.default,
                number: themeData.themeStrings.form.errors.empty.default,
                email: themeData.themeStrings.form.errors.empty.default,
                tel: themeData.themeStrings.form.errors.empty.default,
                checkbox: themeData.themeStrings.form.errors.empty.checkbox
            },
            overflow: {
                number: themeData.themeStrings.form.errors.overflow.default
            },
            pattern: {
                email: themeData.themeStrings.form.errors.pattern.email,
                tel: themeData.themeStrings.form.errors.pattern.tel,
                text: {
                    zipcode: themeData.themeStrings.form.errors.pattern.text.zipcode
                }
            },
            step: {
                number: {
                    default: themeData.themeStrings.form.errors.step.number.default,
                    integer: themeData.themeStrings.form.errors.step.number.integer
                }
            },
            type: {
                email: themeData.themeStrings.form.errors.type.email
            },
            underflow: {
                number: themeData.themeStrings.form.errors.underflow.default
            }
        };

        // Class property for storing caught errors.
        this.errorLog = [];

    }

    /**
     * All dom events of the class.
     * @return {void}
     */
    events() {
    }

    /**
     * This validates form inputs.
     *
     * @param {object} input Input element.
     */
    validate( input ) {

        // Define base values for local variables.
        const inputType  = input.getAttribute( 'type' );
        const inputName  = input.getAttribute( 'name' );
        let errorMessage = '';

        if ( input.validity.badInput ) {

            // Value can't be converted by browser.
            errorMessage = this.errors.input[ inputType ];

        } else if ( input.validity.patternMismatch ) {

            // Value does not match the specified pattern.
            if ( inputType === 'text' ) {
                errorMessage = this.errors.pattern[ inputType ][ inputName ];
            } else {
                errorMessage = this.errors.pattern[ inputType ];
            }

        } else if ( input.validity.rangeOverflow ) {

            // Value is greater than maximum specified by the max attribute.
            errorMessage = this.errors.overflow[ inputType ];
            errorMessage = errorMessage.replace( '%d', input.getAttribute( 'max' ) );

        } else if ( input.validity.rangeUnderflow ) {

            // Value is smaller than minimum specified by the min attribute.
            errorMessage = this.errors.underflow[ inputType ];
            errorMessage = errorMessage.replace( '%d', input.getAttribute( 'min' ) );

        } else if ( input.validity.stepMismatch ) {

            // Value doesn't match the specified step argument.
            const inputStep = input.getAttribute( 'step' );

            if ( inputStep == 1 ) {

                // Step is one, which means that we only allow integers.
                errorMessage = this.errors.step[ inputType ].integer;

            } else {

                // Figure out previous and next valid value.
                const dividedValue   = input.value / inputStep;
                const prevValidValue = Math.floor( dividedValue ) * inputStep;
                const nextValidValue = Math.ceil( dividedValue ) * inputStep;

                // Set error and replace placeholders with nearest valid values.
                errorMessage = this.errors.step[ inputType ].default;
                errorMessage = errorMessage.replace( '%1$d', prevValidValue );
                errorMessage = errorMessage.replace( '%2$d', nextValidValue );

            }

        } else if ( input.validity.typeMismatch ) {

            // Value is not in the correct syntax (email or url).
            errorMessage = this.errors.type[ inputType ];

        } else if ( input.validity.valueMissing ) {

            // Required value is missing.
            errorMessage = this.errors.empty[ inputType ];

        }

        // Set custom validity message.
        input.setCustomValidity( errorMessage );

        if ( errorMessage !== '' ) {

            // Log error in class property errorLog.
            this.errorLog.push([
                inputName,
                errorMessage
            ]);

        }

        return true;
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
    }
}

// Export the class reference.
module.exports = Validator;



// WEBPACK FOOTER //
// ./assets/scripts/validator.js